import type { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityContentBlueprint } from "@backstage/plugin-catalog-react/alpha";

import { isGcpSecurityFindingsAvailable } from "../entityFilter";

/**
 * Entity content extension that renders the Cloud Findings tab on the catalog
 * entity page for entities with GCP project annotations.
 *
 * @alpha
 */
export const cloudFindingsContent: ExtensionDefinition =
    EntityContentBlueprint.make({
        name: "cloud-findings",
        params: {
            path: "/cloud-findings",
            title: "Cloud Findings",
            filter: isGcpSecurityFindingsAvailable,
            loader: () =>
                import("../views/CloudFindingsTab").then(m => (
                    <m.CloudFindingsTab />
                )),
        },
    });
